var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c(
        "w-card-title",
        [
          _vm._v(" Operationele jobs "),
          _c("w-spacer"),
          _vm._v(" " + _vm._s(_vm.jobs.length) + " "),
        ],
        1
      ),
      _vm.jobs.length == 0
        ? _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c("w-col", { attrs: { xs: "12" } }, [
                    _vm._v(" Geen jobs bezig "),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "w-scroll-view",
            { attrs: { tag: "w-list" } },
            _vm._l(_vm.jobs, function (job) {
              return _c(
                "w-list-item",
                { key: job.key },
                [
                  _c("w-list-item-text", [
                    _c("div", [_vm._v(_vm._s(job.Name))]),
                    _c(
                      "div",
                      [
                        _c(
                          "w-link",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openDossier(job.DossierID)
                              },
                            },
                          },
                          [_vm._v("Dossier: " + _vm._s(job.DossierID))]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "w-list-item-action",
                    [
                      _c(
                        "w-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.openCompany(job.DossierID)
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "external-link-alt" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }